import * as Constants from './../application/constants'

export const ACTIONS = {
  NOTIFICATION: 'notify',
  NOTIFICATION_DISMISS: 'notify-dismiss'
}

export default {
  success: (content) => ({ type: ACTIONS.NOTIFICATION, payload: { type: Constants.STATUS.OK, message: content }}),
  error: (content) => ({ type: ACTIONS.NOTIFICATION, payload: { type: Constants.STATUS.ERROR, message: content }}),
  dismiss: () => ({ type: ACTIONS.NOTIFICATION_DISMISS })
}
